import { MapListeners } from "./MapListeners";
import { MapPanels } from "../panels/MapPanels";
import { MapControls } from "./controls/MapControls";
import { MapSelectedPosition } from "./MapSelectedPosition";
import { MapProviders } from "../providers/MapProviders";
import { MapLocations } from "./MapLocations";
import { IMapParamsService } from "../services/MapParamsService";

interface MapCommonProps {
    pilotageId: number,
    shipId: number,
    showCertificateLocations: boolean,
    showSearch: boolean,
    showSettings: boolean,
    showMultiSelect: boolean,
    showAis: boolean,
    canClickPosition: boolean,
    hasPilotageLoaded: boolean,
    hasShipPositionLoaded: boolean,
    pilotage: any,
    pecExam: any,
    position: google.maps.LatLng | null,
    positionType: string,
    selectedPosition: google.maps.LatLng | null,
    setSelectedPosition: (e: google.maps.LatLng) => void,
    onMultiSelectCancelClick: () => void,
    onMultiSelectOkClick: () => void,
    paramsService: IMapParamsService,
}

export const MapCommon = ({
    pilotageId,
    shipId,
    showCertificateLocations,
    showSearch,
    showSettings,
    showMultiSelect,
    showAis,
    pilotage,
    pecExam,
    position,
    positionType,
    selectedPosition,
    setSelectedPosition,
    canClickPosition = false,
    hasPilotageLoaded,
    hasShipPositionLoaded,
    onMultiSelectCancelClick,
    onMultiSelectOkClick,
    paramsService,
}: MapCommonProps) => {

    return (
        <>
            <MapListeners
                hasPilotageLoaded={hasPilotageLoaded}
                hasShipPositionLoaded={hasShipPositionLoaded}
                paramsService={paramsService}
            />

            {
                (showSearch || showSettings) &&
                <MapPanels
                    showSettings={showSettings}
                    showAis={showAis}
                    pilotage={pilotage}
                    paramsService={paramsService}
                    pecExam={pecExam}
                />
            }

            <MapControls
                pilotageId={pilotageId}
                shipId={shipId}
                showSettings={showSettings}
                showSearch={showSearch}
                showMultiSelect={showMultiSelect}
                pecExam={pecExam}
                pilotage={pilotage}
                paramsService={paramsService}
                onMultiSelectCancelClick={onMultiSelectCancelClick}
                onMultiSelectOkClick={onMultiSelectOkClick}
            />

            <MapSelectedPosition
                position={position}
                positionType={positionType}
                selectedPosition={selectedPosition}
                setSelectedPosition={setSelectedPosition}
                canClick={canClickPosition}
            />

            <MapProviders/>

            <MapLocations
                pilotageId={pilotageId}
            />

        </>
    )
}
